import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import GlobalInject from 'themes/global-inject'
import moment from 'moment'
import 'moment-timezone'
import 'moment/locale/da.js'
import Layout from '../layouts'
import '@it25syv/25syv-ui/dist/25syv-ui.css'

window.onload = () => {
    moment.locale('da')
}

const App = () => (
    <BrowserRouter>
        <GlobalInject />
        <Layout />
    </BrowserRouter>
)

export default App
